import { render, staticRenderFns } from "./AddTagForm.vue?vue&type=template&id=a949986e&"
import script from "./AddTagForm.vue?vue&type=script&lang=js&"
export * from "./AddTagForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports